import styled from 'styled-components';
import {useSelector} from "react-redux";

import React, {useState} from "react";
import {Ellipsis, MessageCircle, Pencil, Shield} from "lucide-react";
import {useLoggedIn, useUsername} from '../store';
import {useCommentVote} from "../api/comment";
import useFeedback from "../utils/use_feedback";
import {selectCommentVoteState} from "../store/selectors";
import useModal from "../modals";
import {themecolors} from "../utils/themecolors";
import {CommentVote} from "./vote";
import Sheet from "./bottom-sheet/sheet";
import CommentActionsSheet from "./bottom-sheet/comment_actions";
import CommentManageSheet from "./bottom-sheet/comment_manage";
import ModerateContentSheet from "./bottom-sheet/moderate_content";
import {useSheetModal} from "./test/ModalContext";
import SignupPromptSheet from "./bottom-sheet/signup_prompt";
import {BareButton} from "./button";

export const CommentCount = styled.div``;
export const MoreOptions = styled.div``;
const Actions = styled.div``;

export const ActionIcon = styled(({className, children, onClick, style}) => {
    return (
        <div className={className} style={style}>
            {onClick ?
                <BareButton onClick={onClick}>
                    {children}
                </BareButton> :
                <div>
                    {children}
                </div>
            }
        </div>
    );
})`
  display: flex;
  align-items: center;
  height: 24px;
  min-width: 28px;
  margin: 2px 0;
  padding: 0 8px;
  justify-content: center;
  font-size: 13px;
  ${BareButton} {
    padding: 0;
    display: flex;
    font-weight: 600;
  }
  div {
    display: flex;
    align-items: center;
    font-weight: 600;
  }
  svg {
    margin: 0 6px;
  }
`;

const CommentActions = styled(({className, comment, isTopLevel, handleReply, collapsed: _1, setCollapsed: _2}) => {
    const { openModal } = useSheetModal();
    const loggedIn = useLoggedIn();
    const {feedbackCh} = useFeedback();
    const vote = useCommentVote(feedbackCh);
    const voteValue = useSelector(selectCommentVoteState(comment?.id));
    const username = useUsername();
    const handleVote = async (dir) => {
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            try {
                await vote(comment, dir);
            } catch {
            }
        }
    };

    const [moderateContentOpen, setModerateContentOpen] = useState(false);
    const handleModeration = () => {
        setModerateContentOpen(true);
    };

    const handleComment = () => {
        handleReply();
    };

    const [actionsOpen, setActionsOpen] = useState(false);
    const [manageOpen, setManageOpen] = useState(false);

    const handleManage = () => {
        setManageOpen(true);
    };

    return (
        <div className={className}>
            <Actions>
                <CommentVote onVote={handleVote} vote={voteValue} score={comment?.score}/>
                <MoreOptions>
                        <ActionIcon onClick={handleComment}>
                            Reply
                        </ActionIcon>
                    {comment?.moderation && (
                            <ActionIcon onClick={handleModeration}>
                                <Shield size={14}/>
                            </ActionIcon>
                    )}
                    {username && username === comment?.author && (
                            <ActionIcon onClick={handleManage}>
                                <Pencil size={14}/>
                            </ActionIcon>
                    )}
                    <ActionIcon onClick={() => setActionsOpen(true)}>
                        <Ellipsis size={13}/>
                    </ActionIcon>
                </MoreOptions>
            </Actions>
            {actionsOpen && <Sheet onClose={() => setActionsOpen(false) } padding={"menu"}><CommentActionsSheet commentId={comment?.id} onClose={() => setActionsOpen(false) }/></Sheet>}
            {manageOpen && <Sheet onClose={() => setManageOpen(false) } padding={"menu"}><CommentManageSheet commentId={comment?.id} onClose={() => setManageOpen(false) } /></Sheet>}
            {moderateContentOpen && <Sheet onClose={() => setModerateContentOpen(false) } padding={"menu"}><ModerateContentSheet comment={comment} onClose={() => setModerateContentOpen(false) } /></Sheet>}
        </div>
    );
})`
  ${Actions} {
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
    margin-bottom: 6px;
    margin-top: 4px;
  }

  ${ActionIcon}:active {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${ActionIcon} {
    padding: 0 12px;
  }
  ${ActionIcon} button {
    align-items: center;
  }
  ${ActionIcon} svg {
    margin: 0;
  }
  ${MoreOptions} {
    margin-right: auto;
    display: flex;
    margin-left: 8px;
  }
  ${MoreOptions} > * {
    display: flex;
  }
`;

export default CommentActions;
